import { AvatarGroup, IconButton, Modal, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import DeleteIcon from '@mui/icons-material/Delete';
import TestDetails from './TestDetails/TestDetails';
import axios from '../util/Axios';
import { StatusAvatar } from './TestStatuses/StatusAvatar';
import CommentIcon from '@mui/icons-material/Comment';
import TestDeletDialog from './TestDetails/TestDeletDialog';
import { useSelector } from 'react-redux';
import { USER_ROLES } from '../util/Constants';

export default function TestDetailsList({ email, fromDate, toDate }) {

  const loggedUser = useSelector((state) => state.GlobalReducer.loggedUser);

  const [tests, setTests] = useState([]);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [openVideo, setOpenVideo] = useState(false);
  const [openedTestId, setOpenedTestId] = useState(null);
  const [deleteDialogOpened, setDeleteDialogOpened] = useState(false);


  useEffect(() => {
    axios(`/strokeTests/details/search?email=${email}&fromDate=${fromDate}&toDate=${toDate}&sort=createdAt,desc&size=1000`).then((response) => {
      const tests = response.data.content;
      setTests(tests);
      setShouldRefresh(false);
    });
  }, [shouldRefresh, email, fromDate, toDate]);

  const handleOpenVideo = (testId) => {
    setOpenedTestId(testId);
    setOpenVideo(true);
  };

  const handleCloseVideo = () => {
    setOpenVideo(false);
    setOpenedTestId(null);
    setShouldRefresh(true);
  };

  const handleOpenDeleteDialog = (testId) => {
    setOpenedTestId(testId)
    setDeleteDialogOpened(true);
  };

  const updateTests = () => {
    setTests(prev => prev.filter(t => t.uuid !== openedTestId))
  }

  return (
    <>
      <Table size="small" aria-label="purchases">
        <TableHead>
          <TableRow>
            <TableCell>Doctor</TableCell>
            <TableCell>Patient</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Comment</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Details</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tests.map((test) => (
            <TableRow key={test.uuid}>
              <TableCell>{test.doctor?.name}</TableCell>
              <TableCell>{test.userId}</TableCell>
              <TableCell>
                <AvatarGroup>
                  <StatusAvatar status={test.faceStatus} type="face" />
                  <StatusAvatar status={test.speechStatus} type="speech" />
                  <StatusAvatar status={test.armsStatus} type="arms" />
                  <StatusAvatar status={test.neurologicalExaminationStatus} type="neurologicalExamination" />
                </AvatarGroup>
              </TableCell>
              <TableCell>
                {test.comment ? (
                  <Tooltip title={test.comment}>
                    <IconButton>
                      <CommentIcon></CommentIcon>
                    </IconButton>
                  </Tooltip>
                ) : (
                  ''
                )}
              </TableCell>
              <TableCell>{test.createdAt.split('.')[0].replace('T', ' ')}</TableCell>
              <TableCell>
                <IconButton onClick={() => handleOpenVideo(test.uuid)}>
                  <InfoIcon />
                </IconButton>
              </TableCell>
                 <TableCell>
                  {loggedUser.adminRole === USER_ROLES.admin || (loggedUser.adminRole !== USER_ROLES.admin && loggedUser.role === USER_ROLES.doctor && loggedUser.email === test.doctor?.email) ?
                  <IconButton onClick={() => handleOpenDeleteDialog(test.uuid)}>
                  <DeleteIcon />
                </IconButton>
                :
                null}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Modal open={openVideo} onClose={handleCloseVideo}>
        <TestDetails id={openedTestId} onClose={handleCloseVideo}></TestDetails>
      </Modal>
      {deleteDialogOpened && 
      <TestDeletDialog 
      isOpen={deleteDialogOpened} 
      handleClose={() => setDeleteDialogOpened(false)} 
      testId={openedTestId} 
      setTestId={setOpenedTestId}
      updateTests={updateTests}/>
      }
    </>
  );
}
